<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="6" xl="6">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5" v-if="atualizacaoCadastral.status == 0">
                            DADOS CADASTRAIS ATUAIS -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                        <span class="h5" v-if="atualizacaoCadastral.status != 0">
                            DADOS CADASTRAIS NA SOLICITAÇÃO -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <dados-fornecedor :fornecedor="dadosRm" :md="4" :lg="3" :xl="2"></dados-fornecedor>
                    </b-card-body>
                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                            <span>
                                <i class="fa fa-history"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
            <b-col sm="12" md="12" lg="6" xl="6">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            ATUALIZAÇÃO CADASTRAL -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                        <h5 class="heading-1">
                            <span>PROCESSO</span>
                        </h5>
                        <app-k-v titulo="Status" :md="4" :lg="3" :xl="2">
                            <app-status :status="atualizacaoCadastral.statusDescr"></app-status>
                        </app-k-v>
                        <app-k-v
                            titulo="Data Solicitação"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.dataCadastro"
                        ></app-k-v>
                        <app-k-v
                            titulo="Atualizado em"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.dataAtualizacao"
                            v-if="atualizacaoCadastral.status == 0"
                        ></app-k-v>
                        <app-k-v
                            titulo="Aprovado em"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.dataAtualizacao"
                            v-if="atualizacaoCadastral.status == 1"
                        ></app-k-v>
                        <app-k-v
                            titulo="Reprovado em"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.dataAtualizacao"
                            v-if="atualizacaoCadastral.status == 2"
                        ></app-k-v>
                        <app-k-v
                            titulo="Atualizado por"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.usuarioAtualizacao"
                            v-if="atualizacaoCadastral.status == 0"
                        ></app-k-v>
                        <app-k-v
                            titulo="Aprovado por"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.usuarioAtualizacao"
                            v-if="atualizacaoCadastral.status == 1"
                        ></app-k-v>
                        <app-k-v
                            titulo="Reprovado por"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.usuarioAtualizacao"
                            v-if="atualizacaoCadastral.status == 2"
                        ></app-k-v>
                        <app-k-v
                            titulo="Justificativa"
                            :md="4"
                            :lg="3"
                            :xl="2"
                            :dado="atualizacaoCadastral.justificativa"
                            v-if="atualizacaoCadastral.status == 2"
                        ></app-k-v>
                        <h5 class="heading-1 mt-4">
                            <span>DADOS DO FORNECEDOR</span>
                        </h5>
                        <dados-a-serem-atualizados
                            :dadosCadastrais="atualizacaoCadastral"
                            :mostrarData="false"
                        ></dados-a-serem-atualizados>
                    </b-card-body>
                    <b-card-footer v-if="atualizacaoCadastral.status == 0">
                        <btn-aprovar
                            :atualizacaoCadastralId="atualizacaoCadastral.atualizacaoCadastralId"
                            :cpfCnpj="dadosRm.cpfCnpj"
                            :razaoSocial="dadosRm.nome"
                            @obterAtualizacaoCadastralAtualizada="obterAtualizacaoCadastralAtualizada()"
                        ></btn-aprovar>
                        <btn-reprovar
                            :atualizacaoCadastralId="atualizacaoCadastral.atualizacaoCadastralId"
                            :cpfCnpj="dadosRm.cpfCnpj"
                            :razaoSocial="dadosRm.nome"
                            @obterAtualizacaoCadastralAtualizada="obterAtualizacaoCadastralAtualizada()"
                        ></btn-reprovar>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
import AtualizacoesCadastraisServicos from './AtualizacoesCadastraisServicos'
import DadosASeremAtualizados from './../fornecedor/dadoscadastrais/DadosASeremAtualizados'
import DadosFornecedor from './../fornecedor/dadoscadastrais/DadosFornecedor'
import BtnReprovar from './BtnReprovar'
import BtnAprovar from './BtnAprovar'

export default {
	components: {
		DadosASeremAtualizados,
		DadosFornecedor,
		BtnAprovar,
		BtnReprovar
	},

	data() {
		return {
			dadosRm: {},
			atualizacaoCadastral: {},
			operacao: 'DETALHAR',
			erros: []
		}
	},

	methods: {
		voltar() {
			this.$router.push({ name: 'GestaoAtualizacoesCadastrais' })
		},

		obterAtualizacaoCadastral() {
			this.$store.dispatch('addRequest')
			AtualizacoesCadastraisServicos.obterPorId(
				this.$route.params.atualizacaoCadastralId
			).then(response => {
				if (response) {
					if (response.success) {
						this.dadosRm = response.data.dadosRm
						this.atualizacaoCadastral =
							response.data.atualizacaoCadastral
						this.normalizarDadosRm()
						this.normalizarAtualizacaoCadastral()
					} else {
						this.erros = response.errors
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		normalizarDadosRm() {
			this.dadosRm.ultimaAtualizacao = this.$maskDate(
				this.dadosRm.ultimaAtualizacao
			)
			this.dadosRm.cpfCnpj = this.$maskCpfCnpj(this.dadosRm.cpfCnpj)
			this.dadosRm.telefone = this.$maskTelefone(this.dadosRm.telefone)
			this.dadosRm.cep = this.$maskCep(this.dadosRm.cep)
		},

		normalizarAtualizacaoCadastral() {
			this.atualizacaoCadastral.dataCadastro = this.$maskDateTime(
				this.atualizacaoCadastral.dataCadastro
			)
			this.atualizacaoCadastral.dataAtualizacao = this.$maskDateTime(
				this.atualizacaoCadastral.dataAtualizacao
			)
			this.atualizacaoCadastral.telefone = this.$maskTelefone(
				this.atualizacaoCadastral.telefone
			)
			this.atualizacaoCadastral.cep = this.$maskCep(
				this.atualizacaoCadastral.cep
			)
		},

		obterAtualizacaoCadastralAtualizada() {
			this.$store.dispatch('setRecarregar', true)
			this.obterAtualizacaoCadastral()
		}
	},

	computed: {},

	created() {
		this.obterAtualizacaoCadastral()
	}
}
</script>
